"use strict";

import { createPage } from "./pageBuilder";
import menu from "./content/menu";
import pages from "./content/pages";
import projects from "./content/projects";
import { languages } from "./company";

const routes = {};
const templates = {};

// let lang = localStorage.getItem('user_language');
let lang = 'en';

const getRoute = (path, template) => {
    if (typeof template === 'function') {
        routes[path] = template;
    } else if (typeof template === 'string') {
        routes[path] = templates[template];
    }
};

const getTemplate = (name, templateFunction) => {
    templates[name] = templateFunction;
};

const resolveRoute = (route) => {
    try {
        return routes[route];
    } catch (e) {
        throw new Error(`Route ${route} not found`);
    }
};

const router = () => {
    const route = resolveRoute(window.location.pathname);
    route && route();
}

const createHierarchicalLinks = (parent, index, source) => {
    if (parent.content) {
        parent.content.forEach(child => {
            assignLink(child, index, source);
        });

        setDefaultLink(parent, index, source);
    }
}

const assignLink = (child, index, source) => {
    const id = child.id || child[lang].id
    const url = id !== "home"
        ? `/${lang}/${child.menuItem && child.menuItem[lang] && child.menuItem[lang].url ? child.menuItem[lang].url : child[lang]?.url}`
        : `/${lang}`;
    createHierarchicalLinks(child, index, source);
    getTemplate(id, () => createPage(source[index]));
    getRoute(url, id);
}

const setDefaultLink = (parent, index, source) => {
    getTemplate(parent.id, () => createPage(source[index]));
    parent.content && parent.content[0]?.menuItem[lang]?.url && getRoute(parent.content[0]?.menuItem[lang]?.url, parent.id);
}

export const assignLinks = (source) => {
    source.forEach((item, index) => assignLink(item, index, source));
};

assignLinks([...menu, ...projects, ...pages]);
window.addEventListener('load', router);
window.addEventListener('hashchange', router);

if (!lang) {
    lang = Object.keys(languages).find((language) => language === navigator.language?.slice(0, 2)) || "en";
    localStorage.setItem("user_language", lang);
} else if (location.pathname === "/") {
    location.pathname = `/${lang}`;
} else if (location.pathname !== `/${lang}`) {
    if (!location.pathname.includes(`/${lang}/`)) {
        if (Object.keys(languages).some((language) => location.pathname.includes(`/${language}/`) || location.pathname.includes(`/${language}`))) {
            Object.keys(languages).forEach((language) => {
                if (language !== lang) {
                    if (location.pathname === `/${language}`) {
                        location.pathname = `/${lang}`
                    } else if (location.pathname.includes(`/${language}/`)) {
                        location.pathname = location.pathname.replace(`/${language}/`, `/${lang}/`)
                    }
                }
            })
        } else {
            location.pathname = `/${lang}${location.pathname}`
        }

    } else if (Object.keys(routes) && !Object.keys(routes).includes(location.pathname)) {
        location.pathname = `/${lang}`
    }
}
